var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastTurnament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85552 9.19803H4.85515C6.29483 5.39814 10.4586 3.19686 14.4886 4.27292C18.7809 5.41902 21.3305 9.80699 20.1832 14.0737C19.0359 18.3404 14.6262 20.8703 10.3339 19.7241C7.14692 18.8732 4.9207 16.235 4.45508 13.1863",
    stroke: "#FF9355",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11133 7.28662L4.8559 9.1983",
    stroke: "#FF9355",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 8.79834V11.999L14.0573 13.5992",
    stroke: "#FF9355",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastTurnament);
export default __webpack_public_path__ + "static/media/past-turnament.95b6b01b306048b32faee234bc6432c2.svg";
export { ForwardRef as ReactComponent };